<template>
  <slidePopup ref="slidePopup">
    <div class="scroll_area"  style="height:800px;">
      <div class="inner">
        <strong class="title">상품코드 찾기</strong>
          <div class="pop_con_wrap">
            <div class="search">
              <div class="tab_radio_wrap w900">
                <div class="tab_radio">
                  <div class="custom-radio-02">
                    <input type="radio" id="pro01"  name="tabspro"  class="radio"  checked="checked"><label for="pro01">차량번호</label>
                  </div>
                  <div class="custom-radio-02">
                    <input type="radio" id="pro02" name="tabspro"  class="radio"><label for="pro02">차대번호</label>
                  </div>
                  <div class="custom-radio-02">
                    <input type="radio" id="pro03" name="tabspro"  class="radio"><label for="pro03">모델명 검색</label>
                  </div>
                  <div class="custom-radio-02">
                    <input type="radio" id="pro04" name="tabspro"  class="radio"><label for="pro04">카달로그</label>
                  </div>
                </div>
              </div>
              <div class="pop_search_bg bgf7 w900">
                <div class="input-group-02">
                  <div class="colum-02">
                    <div class="form_box-02">
                      <label for="code">제조사</label>
                      <input type="text" id="code"  class="input-text" placeholder="폭스바겐" value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="colum-02 ">
                    <div class="form_box-02">
                      <label for="code">모델명</label>
                      <input type="text" id="code"  class="input-text" placeholder="컨버터블" value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="colum-02 col-1">
                    <div class="form_group">
                      <a href="javascript:void(0);" class="account_btn" @click="test">조회</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
        </div>
      </div>
    </div> 
  </slidePopup>
</template>

<script> 
import SlidePopup from '@/components/SlidePopup' 

export default {
  name : 'testSlidePopup',
  components: { SlidePopup },
  methods : {
    open () {
      this.$refs.slidePopup.open();

      // 데이터 초기화/조회 등 먼가 함...
    },
    test () {
      this.$emit('test-slide-complete');
      this.$refs.slidePopup.close();
    }
  }
}
 </script>


// WEBPACK FOOTER //
// src/views/test/TestSlidePopup.vue